export const statuses = [
  {
    value: 'PENDING',
    label: 'PENDENTE',
  },
  {
    value: 'SENT',
    label: 'ENVIADO',
  },
  {
    value: 'IN_REVIEW',
    label: 'EM REVISAO',
  },
  {
    value: 'CLOSED_WON',
    label: 'FECHADO/GANHO',
  },
  {
    value: 'CLOSED_LOST',
    label: 'FECHADO/PERDIDO',
  },
];
